import { createSelector } from "@reduxjs/toolkit";

import type { Asset } from "@/Dashboard/pages/AssetLibrary/types";

interface CurrentSelectedItems {
  selectAll: boolean;
  selectMode: boolean;
  selectedItems: Record<string, Asset>;
  selectedItemOrder: string[];
  changed: number;
}

interface CurrentSelectedItemsState {
  currentSelectedItems: CurrentSelectedItems;
}

export const currentSelectedItemsSelector = createSelector(
  (state: CurrentSelectedItemsState) => state.currentSelectedItems,
  (currentSelectedItems) => ({
    ...currentSelectedItems,
  }),
);
